export default __webpack_public_path__ + "static/media/img--kitchen-1-dark.da68a04b.jpg";